import { render, staticRenderFns } from "./UnsubscribeMany.vue?vue&type=template&id=1f76d57d&lang=pug"
import script from "./UnsubscribeMany.vue?vue&type=script&lang=js"
export * from "./UnsubscribeMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports